<layout-default [options]="options" [asideUser]="asideUserTpl" [nav]="navTpl" [content]="contentTpl"
                [customError]="null" appKeyboardShortcuts>
  <layout-default-header-item direction="left">
    <button type="button" aria-label="Lock screen" style="color: white; background: none; border: none; padding: 0; cursor: pointer;" layout-default-header-item-trigger (click)="lockApp()" nz-tooltip nzTooltipTitle="Lock"
       nzTooltipPlacement="bottom">
      <i nz-icon nzType="lock"></i>
    </button>
  </layout-default-header-item>
  <layout-default-header-item direction="left">
    <header-tour></header-tour>
  </layout-default-header-item>
  <layout-default-header-item direction="left" hidden="pc">
    <div layout-default-header-item-trigger [class.my-header-search]="isSmallScreen"
         (click)="searchToggleStatus = !searchToggleStatus">
      <i nz-icon nzType="search"></i>
    </div>
  </layout-default-header-item>
  <layout-default-header-item direction="middle">
    <header-search class="alain-default__search" [class.my-header-search]="!isSmallScreen"
                   [toggleChange]="searchToggleStatus"></header-search>
  </layout-default-header-item>
  <layout-default-header-item direction="right">
    <header-chat #chat></header-chat>
  </layout-default-header-item>
  <layout-default-header-item direction="right">
    <header-notify></header-notify>
  </layout-default-header-item>
  <layout-default-header-item direction="right">
    <header-marketplace></header-marketplace>
  </layout-default-header-item>
  <layout-default-header-item direction="right">
    <header-chatbot></header-chatbot>
  </layout-default-header-item>
  <layout-default-header-item direction="right">
    <header-support></header-support>
  </layout-default-header-item>

  <!-- show only in mobile view -->
  <layout-default-header-item direction="right">
    <header-mobile-dropdown-nav></header-mobile-dropdown-nav>
  </layout-default-header-item>
  <!-- //end -->

  <layout-default-header-item direction="right">
    <header-user></header-user>
  </layout-default-header-item>

  <ng-template #asideUserTpl>
    <div *ngIf="!isCollapsed" nz-dropdown [nzDropdownMenu]="userMenu" nzTrigger="click"
         class="alain-default__aside-user sidebar-user-info">
      <div class="alain-default__aside-user-info">
        <strong class="text-truncate mb0">{{ company.companyName }}</strong>
        <div class="company-id-line">
          <span nz-typography class="text-primary">Company ID: </span>
          <span appCopyButtonAriaLabel="Copy Company ID">
            <span nz-typography nzCopyable [nzContent]="company.tenantCode" class="text-primary"
                (click)="$event.stopPropagation()">
            </span>
          </span>
        </div>

        <nz-divider class="info-divider"></nz-divider>
      </div>
    </div>
    <div *ngIf="!isCollapsed" class="alain-default__aside-user sidebar-license-info">
      <div *ngIf="company.dbType || company.licensed || company.isSample || company.isFreeTrial">
        <nz-tag nzColor="blue" *ngIf="company.dbType" class="tag-text"> {{ company.dbType }}</nz-tag>
        <ng-container *ngIf="(company.licensed|| company.isFreeTrial) && !company.isSample">
          <ng-container *ngIf="licenseText.includes('Licensed')">
            <nz-tag nzColor="success" class="tag-text">
              <button type="button" class="tag-action-btn" aria-label="View license details" (click)="showLicense()"> {{ licenseText }}</button>
            </nz-tag>
          </ng-container>
          <nz-tag nzColor="error" *ngIf="licenseText.includes('Expired')" class="tag-text"> {{ licenseText }}</nz-tag>
          <nz-tag nzColor="error" *ngIf="!['Licensed', 'Expired'].includes(licenseText)" class="tag-text">
            <button type="button" class="tag-action-btn" aria-label="Go to upgrade plan" (click)="navigateToPlan()">{{ licenseText }}</button>
          </nz-tag>
        </ng-container>
        <ng-container *ngIf="company.isSample">
          <nz-tag [nzColor]="'#f50'" class="tag-text"> {{ 'DEMO' }}</nz-tag>
          <nz-tag nzColor="red" class="tag-text"> {{ 'RESET IN ' + company.resetDaysLeft + ' DAY(S)' }}</nz-tag>

          <ng-container *ngIf="progress && progress !== 0 && progress !== 100">
            <div style="margin-top: 5px;">
              <nz-tag nzColor="lime">
                <span nz-icon nzType="sync" nzSpin></span>
                {{ 'Setting up sample data - ' + progress.toString() + '%' }}
              </nz-tag>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <nz-dropdown-menu #userMenu="nzDropdownMenu">
      <ul nz-menu>
        <li nz-menu-item routerLink="/account/companies">
          <i nz-icon nzType="appstore" class="mr-sm"></i>
          My Companies
        </li>
        <li nz-menu-item routerLink="/account/settings">
          <i nz-icon nzType="setting" class="mr-sm"></i>
          Account Settings
        </li>
        <li nz-menu-item>
          <i nz-icon nzType="read" class="mr-sm"></i>
          <a style="color: unset;" [href]="this.academyLink" target="_blank" rel="noopener noreferrer">
            QNE Academy
          </a>
        </li>
        <li nz-menu-item>
          <i nz-icon nzType="global" class="mr-sm"></i>
          <a style="color: unset;" [href]="this.websiteLink" target="_blank" rel="noopener noreferrer">
            QNE Website
          </a>
        </li>
        <li nz-menu-item>
          <i nz-icon nzType="read" class="mr-sm"></i>
          <a style="color: unset;" [href]="this.youtubeLink" target="_blank" rel="noopener noreferrer">
            Youtube Channel
          </a>
        </li>
        <li nz-menu-item routerLink="/company/adv-opts">
          <i nz-icon nzType="tool" class="mr-sm"></i>
          Advanced Options
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item (click)="logout()">
          <i nz-icon nzType="logout" class="mr-sm"></i>
          Logout
        </li>
      </ul>
    </nz-dropdown-menu>
  </ng-template>
  <ng-template #navTpl>
    <div class="scrollbar">
      <app-nav class="d-block py-lg" />
    </div>
  </ng-template>
  <ng-template #contentTpl>
    <app-migration-banner />
    <div appReuseTabExtraAriaLabel="Add tab">
    <reuse-tab #reuseTab (close)="closeTab($event)"></reuse-tab>
    <router-outlet (activate)="addTab(reuseTab, $event)" (attach)="addTab(reuseTab, $event)">
    </router-outlet>
    <global-footer [links]="[]">
      Copyright
      <i nz-icon nzType="copyright"></i> {{ this.copyrightYear }}
      <a href="{{ this.QNELink }}" target="_blank" rel="noopener">{{ this.companyName }}</a>
      {{ this.buildDisplay }}
    </global-footer>
    </div>
  </ng-template>
</layout-default>

<app-page-how-to></app-page-how-to>

<app-fcwidget></app-fcwidget>

<setting-drawer *ngIf="showSettingDrawer"></setting-drawer>
<theme-btn *ngIf="showSettingDrawer"></theme-btn>


<app-init-sample *ngIf="company.isSample" [progress]="progress">
</app-init-sample>

<financial-advisor-header></financial-advisor-header>
<app-license-notification></app-license-notification>
<app-mfa-prompt></app-mfa-prompt>
<app-prompt-card-runner></app-prompt-card-runner>

@if (qbotWidgetService.showReportAnalyzerWidget()) {
  <app-q-bot-report-analyzer />
}



<!-- <app-einv-wizard-auto-play [acl]="{ ability: ['einv.enabled', 'country.MY', 'admin'] }" /> -->
